import snakecaseKeys from 'snakecase-keys';
import { CosmosBankV1Beta1Bank, InjectiveTokenFactoryV1Beta1Tx, } from '@injectivelabs/core-proto-ts';
import { MsgBase } from '../../MsgBase.js';
/**
 * @category Messages
 */
export default class MsgSetDenomMetadata extends MsgBase {
    static fromJSON(params) {
        return new MsgSetDenomMetadata(params);
    }
    toProto() {
        const { params } = this;
        const metadata = CosmosBankV1Beta1Bank.Metadata.create();
        metadata.description = params.metadata.description;
        metadata.denomUnits = params.metadata.denomUnits.map((value) => {
            const denomUnit = CosmosBankV1Beta1Bank.DenomUnit.create();
            denomUnit.denom = value.denom;
            denomUnit.exponent = value.exponent;
            denomUnit.aliases = value.aliases;
            return denomUnit;
        });
        metadata.base = params.metadata.base;
        metadata.display = params.metadata.display;
        metadata.name = params.metadata.name;
        metadata.symbol = params.metadata.symbol;
        metadata.uri = params.metadata.uri;
        metadata.uriHash = params.metadata.uriHash;
        metadata.decimals = params.metadata.decimals;
        const message = InjectiveTokenFactoryV1Beta1Tx.MsgSetDenomMetadata.create();
        if (params.adminBurnDisabled !== undefined) {
            const adminBurnDisabled = InjectiveTokenFactoryV1Beta1Tx.MsgSetDenomMetadata_AdminBurnDisabled.create();
            adminBurnDisabled.shouldDisable = params.adminBurnDisabled;
            message.adminBurnDisabled = adminBurnDisabled;
        }
        message.sender = params.sender;
        message.metadata = metadata;
        return InjectiveTokenFactoryV1Beta1Tx.MsgSetDenomMetadata.fromPartial(message);
    }
    toData() {
        const proto = this.toProto();
        return {
            '@type': '/injective.tokenfactory.v1beta1.MsgSetDenomMetadata',
            ...proto,
        };
    }
    toAmino() {
        const proto = this.toProto();
        const message = {
            ...snakecaseKeys(proto),
        };
        return {
            type: 'injective/tokenfactory/set-denom-metadata',
            value: message,
        };
    }
    toWeb3Gw() {
        const amino = this.toAmino();
        const { value } = amino;
        return {
            '@type': '/injective.tokenfactory.v1beta1.MsgSetDenomMetadata',
            ...value,
        };
    }
    toDirectSign() {
        const proto = this.toProto();
        return {
            type: '/injective.tokenfactory.v1beta1.MsgSetDenomMetadata',
            message: proto,
        };
    }
    toBinary() {
        return InjectiveTokenFactoryV1Beta1Tx.MsgSetDenomMetadata.encode(this.toProto()).finish();
    }
}
